import { ENTERPRISE_PARTNER_ID } from '@brighte/enterprise-common/constants';

import { usePartnerConfig } from '~/context/PartnerConfigContext';
import { MarketplacePartner } from '~/types/marketplace';

export const usePartner = (): MarketplacePartner => {
  const config = usePartnerConfig();
  return (config?.id ?? ENTERPRISE_PARTNER_ID.brighte) as MarketplacePartner;
};
